import * as Sentry from '@sentry/browser';

export const initSentry = (environment) => {
  const dsn = 'https://546d26674381408f9cbc1f852e287a7b@sentry.io/1776262';
  Sentry.init({ dsn, environment: environment || 'development' });
};
